import { createStore, createEvent } from 'effector';
import { nanoid } from 'nanoid';

type Modals = {
  [key: string]: boolean;
};
const $modals = createStore<Modals>({});
const initModal = createEvent<string>();
const destroyModal = createEvent<string>();

const openModal = createEvent<string>();
const closeModal = createEvent<string>();
const toggleModal = createEvent<string>();
const changeModal = createEvent<{ id: string; value: boolean }>();

$modals
  .on(initModal, (state, id) =>
    state[id]
      ? state
      : {
          ...state,
          [id]: false
        }
  )
  .on(destroyModal, (state, id) => ({ ...state, [id]: undefined }))
  .on(openModal, (state, id) => ({
    ...state,
    [id]: true
  }))
  .on(closeModal, (state, id) => ({
    ...state,
    [id]: false
  }))
  .on(toggleModal, (state, id) => ({
    ...state,
    [id]: !state[id]
  }))
  .on(changeModal, (state, { id, value }) => ({
    ...state,
    [id]: value
  }));

const createModalStore = ({ id: _id }: { id?: string }) => {
  const id: string = _id || nanoid();
  const $store = $modals.map(store => store[id] ?? false);
  const close = () => {
    closeModal(id);
  };
  const open = () => {
    openModal(id);
  };
  const toggle = () => {
    toggleModal(id);
  };
  const change = (value: boolean) => {
    changeModal({ id, value });
  };
  return {
    id,
    $modal: $store,
    close,
    open,
    toggle,
    change
  };
};

const $modalZIndex = createStore<number[]>([1201]);
const addZIndex = createEvent();
const removeZIndex = createEvent();

$modalZIndex
  .on(addZIndex, s => {
    const a = Array.from(s);
    a.push(a[a.length - 1] + 10);
    return a;
  })
  .on(removeZIndex, s => {
    const a = Array.from(s);
    a.pop();
    return a;
  });

const modalMethods = {
  initModal,
  destroyModal,
  openModal,
  closeModal,
  toggleModal,
  changeModal
};

export {
  initModal,
  destroyModal,
  openModal,
  closeModal,
  $modals,
  toggleModal,
  changeModal,
  createModalStore,
  modalMethods,
  $modalZIndex,
  addZIndex,
  removeZIndex
};
